import React, { useState } from 'react';
import { auth } from '../../api';
import './DeleteAccountCard.css';

/**
 * "Your data" block in Settings: links to the privacy policy and, for players, self-service account deletion
 * (required by Google Play / the App Store). Coaches and managers are removed by the head coach.
 */
export default function DeleteAccountCard({ user, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const isPlayer = user && user.role === 'player';
  const ready = password.length > 0 && confirm === 'DELETE';

  const close = () => { if (busy) return; setOpen(false); setPassword(''); setConfirm(''); setError(''); };

  const submit = async (e) => {
    e.preventDefault();
    if (!ready || busy) return;
    setBusy(true);
    setError('');
    try {
      await auth.deleteAccount(password, confirm);
      onDeleted && onDeleted();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not delete the account. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="settings-section dac-block">
      <label>Your data</label>
      <div className="dac-links">
        <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy policy</a>
        <a href="/delete-account.html" target="_blank" rel="noopener noreferrer">How deletion works</a>
      </div>

      {isPlayer ? (
        <>
          <button type="button" className="dac-danger" onClick={() => setOpen(true)}>Delete my account</button>
          <span className="password-info">Permanently removes your account, notes and progress. This cannot be undone.</span>
        </>
      ) : (
        <span className="password-info">Coach and manager accounts are removed by the head coach. Contact them to close yours.</span>
      )}

      {open && (
        <div className="dac-overlay" onClick={close}>
          <form className="dac-sheet" onClick={(e) => e.stopPropagation()} onSubmit={submit} role="dialog" aria-label="Delete my account">
            <h3>Delete your account?</h3>
            <p>This permanently deletes your profile, notes, progress and Spanish learning data. Past lessons stay in your coach's records without your name. <strong>This cannot be undone.</strong></p>

            <label htmlFor="dac-pw">Your password</label>
            <input id="dac-pw" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={busy} />

            <label htmlFor="dac-confirm">Type <b>DELETE</b> to confirm</label>
            <input id="dac-confirm" type="text" autoComplete="off" autoCapitalize="characters" value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={busy} />

            {error && <div className="dac-error" role="alert">{error}</div>}

            <div className="dac-actions">
              <button type="button" className="dac-cancel" onClick={close} disabled={busy}>Keep my account</button>
              <button type="submit" className="dac-danger dac-danger--solid" disabled={!ready || busy}>{busy ? 'Deleting…' : 'Delete forever'}</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
